import { RuleStatuses } from 'app/modules/rules/models';
import moment from 'moment';

export const ACTIVE_STATUSES = ['ACTIVE', 'OPEN'] as const;
export const INACTIVE_STATUSES = [
  'CLOSED',
  'INACTIVE',
  'ARCHIVED',
  'EXPIRED',
] as const;

export const AMOUNT_FORMAT: string = '0,0.00';

export const STANDARD_NUMBER_FORMAT: string = '0,0';

export const LARGE_AMOUNT_FORMAT: string = '0a';

export const SHORT_DECIMAL_FORMAT = '0.00e+0';

// currently in use with moment.js - incompatible with date-fns
export const BE_DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';
// format string passed to date-fns format function - replaces BE_DATE_FORMAT
export const BE_DATE_FORMAT_FNS = 'yyyy-MM-dd HH:mm:ss';
export const DATE_FORMAT_STR = 'DD MMM YYYY';

export const DEFAULT_ID = -1;

export const MUSTACHE_MATCHER_REGEX = /{{\s*[$\w.]+\s*}}/g;

export const DEFAULT_EXEC_START_DATE_MONTHS_AGO = 3;

// format of value returned from <InputField/> component when type is `datetimepicker`
export const INPUT_FIELD_DATETIME_VALUE_FORMAT = 'DD MMM YYYY HH:mm';

export const PRESET_DATE_WITH_TIME_IN_UTC = moment
  .utc()
  .subtract(DEFAULT_EXEC_START_DATE_MONTHS_AGO, 'months')
  .hours(0)
  .minutes(0)
  .format(INPUT_FIELD_DATETIME_VALUE_FORMAT);

export const DATE_FORMAT_MILITARY_TIME = 'DD MMM YYYY H:mm';

export const INFINITE_SCROLL_LIMIT = 10;

export const ALERT_QUEUE_RULE_STATUSES: RuleStatuses[] = [RuleStatuses.ACTIVE];

export const OFFSET_DEFAULT = 1;

export const PAGE_LIMIT_DEFAULT = 25;

export const TEXT_PLACEHOLDER_DELAY_MS = 300;

export const ARRAY_SIZE_LIMIT = 15;

// default loading height of all tab panes to be consistent
export const DEFAULT_TAB_LOADING_HEIGHT = 400;

export const CUSTOM_DATA_SEPARATOR = '......';

export const PAGE_LIMIT_OPTIONS = [
  { key: 10, value: 10, text: '10 Rows' },
  { key: 25, value: 25, text: '25 Rows' },
  { key: 50, value: 50, text: '50 Rows' },
  { key: 100, value: 100, text: '100 Rows' },
];

export const EXTENDED_PAGE_LIMIT_OPTIONS = [
  { key: 500, value: 500, text: '500 Rows' },
];

export const MAX_PAGINATION_PAGE_COUNT = 300;

export const LABEL_PREDEFINED_COLORS = {
  USER: '#f4a263',
  BUSINESS: '#2c7ca9',
  EXTERNAL: '#965286',
  INTERNAL: '#ddab93',
  OPEN: '#21ba45',
  CLOSED: '#c03c3c',
  ACTIVE: '#52a766',
  INACTIVE: '#c03c3c',
  ALLOWED: '#52a766',
  WATCHLISTED: '#f34949',
  BLOCKED: '#dc4444',
  PLACEHOLDER: '#7f9f87',
  SPOOLED: '#7f9f87',
  TRUE_POSITIVE: '#21ba45',
  FALSE_POSITIVE: '#f34949',
  COMPLETE: '#21ba45',
  FAILED: '#e84b1c',
  GENERATING_VALIDATION_ALERTS: '#23ad9d',
  PENDING: '#43425d',
  QUERY_TIMEOUT: '#e84b1c',
} as const;
